import { useContext } from 'react';
import { MobXProviderContext } from 'mobx-react';
import { useProfileFeatureFlags } from './useProfileStores';
import { IAssetAssignmentsList, ICardSetManageChecks, ICardSetOwnerCompany, ISelectList } from '../../interfaces';

export function useIsCardSetManageEnabled(): boolean {
    return !!useProfileFeatureFlags()?.assetAssignmentsCsManage;
}

export function useCardSetOwnerCompanies(): ICardSetOwnerCompany[] {
    return useContext(MobXProviderContext).RootStore.cardSetManageStore.ownerCompanies;
}

export function useCardSetManageChecks(): ICardSetManageChecks {
    return useContext(MobXProviderContext).RootStore.cardSetManageStore.checks;
}

export function useCardSetFutureAssignments(): IAssetAssignmentsList {
    return useContext(MobXProviderContext).RootStore.cardSetManageStore.futureAssignments;
}

export function useCardSetParentAssignments(): IAssetAssignmentsList {
    return useContext(MobXProviderContext).RootStore.cardSetManageStore.parentAssignments;
}

export function useCardSetManageChildrenSelect(): ISelectList {
    return useContext(MobXProviderContext).RootStore.cardSetManageStore.childrenSelect;
}

export function useCardSetManageCardSetsOptions(companyId?: string): ISelectList {
    const options = useContext(MobXProviderContext).RootStore.cardSetManageStore.cardSetsOptions;
    return (companyId && options[companyId]) || [];
}
